(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acc-full-image"] && !Shopify.designMode) return;
  try {
    
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var items = [];
  var running = false;

  function collect() {
    items = [];
    document.querySelectorAll('.acc-Full-image').forEach(function (section) {
      var max = parseFloat(section.getAttribute('data-zoom-scale')) || 1.15;
      if (max <= 1) return; // effect disabled
      section.querySelectorAll('.js-acc-zoom .acc-Image').forEach(function (img) {
        items.push({ section: section, img: img, max: max, current: max });
      });
    });
  }

  function targetScale(section, max) {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // 0 when section top is at viewport bottom (entering), 1 when top reaches viewport top
    var p = 1 - (rect.top / vh);
    p = Math.min(Math.max(p, 0), 1);
    var eased = 1 - Math.pow(1 - p, 2); // ease-out toward 1.0
    return max - (max - 1) * eased;
  }

  function update() {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var target = targetScale(it.section, it.max);
      it.current += (target - it.current) * 0.15; // lerp for smooth settle
      it.img.style.setProperty('--acc-zoom', it.current.toFixed(4));
    }
    requestAnimationFrame(update);
  }

  function init() {
    if (running) { collect(); return; }
    collect();
    if (!items.length) return;
    running = true;
    requestAnimationFrame(update);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function () { collect(); init(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acc-ingredients-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(section) {
    if (section.dataset.accInit) return;
    section.dataset.accInit = 'true';

    var track = section.querySelector('.js-acc-track');
    var prev = section.querySelector('.js-acc-prev');
    var next = section.querySelector('.js-acc-next');
    var cursor = section.querySelector('.js-acc-cursor');
    var sliderArea = section.querySelector('[data-acc-slider]');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.acc-IngredientsSlider-card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '20') || 20;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // Decorative swipe cursor (desktop, pointer devices)
    if (cursor && sliderArea && window.matchMedia('(hover: hover) and (min-width: 821px)').matches) {
      sliderArea.addEventListener('mouseenter', function () { cursor.classList.add('is-visible'); });
      sliderArea.addEventListener('mouseleave', function () { cursor.classList.remove('is-visible'); });
      sliderArea.addEventListener('mousemove', function (e) {
        var rect = sliderArea.getBoundingClientRect();
        cursor.style.transform = 'translate(' + (e.clientX - rect.left - 60) + 'px,' + (e.clientY - rect.top - 60) + 'px)';
      });
    }
  }

  function boot() {
    document.querySelectorAll('.acc-ingredients-slider-section').forEach(initSlider);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.acc-ingredients-slider-section') || e.target;
    if (s.classList && s.classList.contains('acc-ingredients-slider-section')) initSlider(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acc-tabbed-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(root) {
    if (root.dataset.accTabsInit) return;
    root.dataset.accTabsInit = 'true';

    var toggles = root.querySelectorAll('[data-acc-toggle]');
    var panels = root.querySelectorAll('[data-acc-panel]');
    var images = root.querySelectorAll('[data-acc-panel-image]');

    function activate(index) {
      toggles.forEach(function (t) {
        var on = t.getAttribute('data-acc-toggle') === String(index);
        t.classList.toggle('acc-Tabbed-content-toggle__active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-acc-panel') === String(index);
        p.classList.toggle('acc-Tabbed-content-container__active', on);
        if (on) { p.removeAttribute('inert'); } else { p.setAttribute('inert', ''); }
      });
      images.forEach(function (img) {
        var on = img.getAttribute('data-acc-panel-image') === String(index);
        img.classList.toggle('acc-Tabbed-content-image-container__active', on);
      });
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-acc-toggle'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-acc-tabs]').forEach(initTabs);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-acc-tabs]');
    if (root) initTabs(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
